export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [{
      text: '名称',
      name: 'title',
    }, {
      name: 'type',
      type: 'hidden',
    }, {
      name: 'id',
      type: 'hidden',
    }, {
      name: 'name',
      type: 'hidden',
    }, {
      type: 'component',
      id: 'rect',
    }],
  }],
}];
